module.exports = __webpack_public_path__ + "img/strategy_icon3.c4093d50-1c6bc327.8c3412ed.svg";